/**
 * @constructor
 */
export default function FormMaster($this) {

    var currentStep = $this.data('current-step') << 0 || 1,
        $steps      = $this.find('.js-step'),
        stepsCount  = $steps.length;

    showCurrentStep();

    $this.find('.js-next').on('click', function() {
        currentStep++;
        if (currentStep > stepsCount) {
            currentStep = stepsCount;
        }
        showCurrentStep();
    });

    $this.find('.js-prev').on('click', function() {
        currentStep--;
        if (currentStep < 1) {
            currentStep = 1;
        }
        showCurrentStep();
    });

    function showCurrentStep() {

        $steps.removeClass('visible');
        $steps.filter('[data-step="' + currentStep + '"]').addClass('visible');

        $this.data('current-step', currentStep);
    }
};
